"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonMainCategoriesMobile = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _SkeletonCatalogueMobile = require("./SkeletonCatalogueMobile");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const SkeletonMainCategoriesMobileCategory = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(0, 3, 1),
  minWidth: '80%'
}));
const SkeletonMainCategoriesMobileCategoryLarge = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(5, 3, 1),
  minWidth: '80%'
}));
const SKELETON_HEIGHT = 60;
const SkeletonMainCategoriesMobile = () => {
  const elements = Math.floor(window.innerHeight / SKELETON_HEIGHT);
  const steps = Array.from({
    length: elements
  }, (element, index) => index);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const skeletonElements = steps.map(step => /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonMainCategoriesMobileCategory, {
    height: 37,
    animation: "wave",
    variant: "rectangular"
  }, `categories-mobile-${step}`));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    "data-testid": getTestId(_constants.SKELETON_MAIN_CATEGORY_MOBILE),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonCatalogueMobile.SkeletonCatalogueMobile, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonMainCategoriesMobileCategory, {
      height: 54,
      animation: "wave",
      variant: "rectangular"
    }, "categories-mobile-medium"), skeletonElements, /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonMainCategoriesMobileCategoryLarge, {
      height: 109,
      animation: "wave",
      variant: "rectangular"
    }, "categories-mobile-large")]
  });
};
exports.SkeletonMainCategoriesMobile = SkeletonMainCategoriesMobile;
